import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import EngagementErrors from "./EngagementErrors";
import NewEngagementForm from "./NewEngagementForm";
import jobType from "./types/jobType";

class ErrorsOrForm extends PureComponent {
  render() {
    const {
      createEngagementPath,
      updateEngagementPath,
      errors,
      job: { hasCustomTerms },
      recruiterIsOnPsl,
      recruiterIsInJobAudience,
      isPartnerUser,
    } = this.props;

    const hasErrors = ["job", "recruiter"].some((val) => val in errors);

    if (hasErrors) {
      return <EngagementErrors errors={errors} />;
    }
    return (
      <NewEngagementForm
        createEngagementPath={createEngagementPath}
        updateEngagementPath={updateEngagementPath}
        hasCustomTerms={hasCustomTerms}
        errors={errors}
        recruiterIsOnPsl={recruiterIsOnPsl}
        recruiterIsInJobAudience={recruiterIsInJobAudience}
        isPartnerUser={isPartnerUser}
      />
    );
  }
}

ErrorsOrForm.propTypes = {
  job: jobType.isRequired,
  errors: PropTypes.shape({
    base: PropTypes.arrayOf(PropTypes.string),
    message: PropTypes.arrayOf(PropTypes.string),
    recruiter: PropTypes.arrayOf(PropTypes.string),
  }),
  createEngagementPath: PropTypes.string.isRequired,
  updateEngagementPath: PropTypes.string.isRequired,
  recruiterIsOnPsl: PropTypes.bool,
  recruiterIsInJobAudience: PropTypes.bool,
  isPartnerUser: PropTypes.bool.isRequired,
};

ErrorsOrForm.defaultProps = {
  errors: {},
  recruiterIsOnPsl: false,
  recruiterIsInJobAudience: false,
};

export default ErrorsOrForm;
